export default "__VITE_PUBLIC_ASSET__1de23621__"